// This file is a bridge to support both .js and .tsx entry points
require('./index.tsx');
